const setOneMonthAgo = () => {
  const today = new Date();
  today.setMonth(today.getMonth() - 1);
  today.setHours(0, 0, 0, 0);

  return Math.ceil(today.getTime() / 1000);
};

export default setOneMonthAgo;
